import { Marquee } from "@/components/ui/marquee"

const clientLogos = [
  {
    name: "Kravata",
    src: "/lovable-uploads/c1534b42-cd75-4488-bb90-ba68ebccc08c.png",
    alt: "Kravata logo"
  },
  {
    name: "TierraGro",
    src: "/lovable-uploads/51fd4038-bfd0-48d6-a7d4-28d01dbac491.png",
    alt: "TierraGro - El Supermercado Agropecuario logo"
  },
  {
    name: "AFGlobal",
    src: "/lovable-uploads/b234e8a7-20f8-4492-917f-e8d644f25691.png",
    alt: "AFGlobal logo"
  },
  {
    name: "Credibanco",
    src: "/lovable-uploads/a8993127-3ee7-43cb-b66d-c3c0c1bedae3.png",
    alt: "Credibanco logo"
  },
  {
    name: "APUS",
    src: "/lovable-uploads/aa3bf304-ea06-4be8-877e-caebb5ea9400.png",
    alt: "APUS - Una empresa de Grupo Sura logo"
  },
  {
    name: "Araújo Ibarra",
    src: "/lovable-uploads/8e3f95e8-0d05-4e7c-b78f-5359bb32274f.png",
    alt: "Araújo Ibarra - Consultores en Comercio Internacional logo"
  },
  {
    name: "Corpaul",
    src: "/lovable-uploads/fe856dc3-d262-4ed2-98a4-b3b2169b4912.png",
    alt: "Corpaul logo"
  },
  {
    name: "Cristal UP",
    src: "/lovable-uploads/f1bb2268-276f-406d-99fd-e87caa82ac5d.png",
    alt: "Cristal UP logo"
  },
  {
    name: "LEGO",
    src: "/lovable-uploads/eeafef30-188f-464f-b508-1d9e0f072005.png",
    alt: "LEGO logo"
  },
  {
    name: "INSIDE",
    src: "/lovable-uploads/b3b26b96-0d4f-4781-9933-7971a923c96a.png",
    alt: "INSIDE movement center logo"
  },
  {
    name: "Cargill",
    src: "/lovable-uploads/08d55a61-a90a-4668-a35d-b06be4cbf73f.png",
    alt: "Cargill logo"
  },
  {
    name: "Inexmoda",
    src: "/lovable-uploads/8ae02f44-cce8-4763-8847-b23719ada586.png",
    alt: "Inexmoda - Conoce, Conecta y Transforma logo"
  },
  {
    name: "Parque Explora",
    src: "/lovable-uploads/c416478d-16d5-4cb9-a4e9-1608c639e67d.png",
    alt: "Parque Explora logo"
  },
  {
    name: "Clearpath Coffee",
    src: "/lovable-uploads/72d41958-2773-4e94-ad7b-ef581314ae01.png",
    alt: "Clearpath Coffee Roasters Colombia logo"
  },
  {
    name: "iData",
    src: "/lovable-uploads/a5875637-2401-4a6a-8fdf-9a445117157e.png",
    alt: "iData logo"
  },
  {
    name: "Agua Bendita",
    src: "/lovable-uploads/90d6e3d2-877b-4c58-80aa-54ce7d149a74.png",
    alt: "Agua Bendita logo"
  },
  {
    name: "MAS",
    src: "/lovable-uploads/71a3d5f5-4dd9-4881-86a8-9730c6782003.png",
    alt: "MAS Seguros Somos Más Que Seguros logo"
  },
  {
    name: "Manpower",
    src: "/lovable-uploads/dee6dedc-7cf9-4ee6-8015-479fa0287b6c.png",
    alt: "Manpower logo"
  },
  {
    name: "Credicorp",
    src: "/lovable-uploads/1ff62acb-77f1-456f-98ba-d46f9d3798b7.png",
    alt: "Credicorp logo"
  },
  {
    name: "Anthesis MERO",
    src: "/lovable-uploads/fe518697-a7c6-4fb1-9534-82afd863bb41.png",
    alt: "Anthesis MERO logo"
  },
  {
    name: "Quimpac",
    src: "/lovable-uploads/a8b4048f-6f55-4d46-86fa-b951fdeb12b8.png",
    alt: "Quimpac logo"
  },
  {
    name: "Inbiotech",
    src: "/lovable-uploads/4216784c-0f7c-44c3-a5bd-6f71b83811e8.png",
    alt: "Inbiotech logo"
  },
  {
    name: "Enerlítica",
    src: "/lovable-uploads/250b1197-ffa0-45dd-819b-f597bd04c3bf.png",
    alt: "Enerlítica logo"
  },
  {
    name: "XM",
    src: "/lovable-uploads/4391373f-df04-4852-bd49-048e317b2e47.png",
    alt: "XM logo"
  }
];

export function MarqueeDemo() {
  return (
    <section className="py-16 bg-muted/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Trusted by Leading Companies
          </h2>
          <p className="text-muted-foreground">
            Join hundreds of successful businesses that have optimized their pricing strategies with PriceZing
          </p>
        </div>
        <Marquee pauseOnHover={true} speed={40}>
          {clientLogos.map((logo, index) => (
            <div
              key={index}
              className="relative h-20 w-fit mx-8 flex items-center justify-center bg-white rounded-lg shadow-soft p-6 hover:shadow-medium transition-shadow"
            >
              <img 
                src={logo.src} 
                alt={logo.alt}
                className="h-full w-auto max-w-[200px] object-contain transition-all duration-300"
                loading="lazy"
                width="200"
                height="74"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  )
}